import moment from 'moment'
import { DATE_TIME_FORMATE } from './../../../libs/constants'
import { SUCCESS, WARNING } from './../../../libs/color_util'

function timeRender(key) {
    return (h, {row}) => <span>{moment(row[key]).format(DATE_TIME_FORMATE)}</span>
}

export const freeze_logs_fields = [
    {
        title: '操作类型',
        width: 120,
        key: 'operation',
        align: 'center',
        render(h, {row}) {
            return <span>{row.operation ? '冻结' : '解冻'}</span>
        }
    },
    {
        title: '操作原因',
        key: 'reason',
        align: 'center'
    },
    {
        title:'操作时间',
        width: 200,
        key: 'created_at',
        align: 'center',
        render:timeRender('created_at')
    },
]
export const histories_versions_fields = [
    {
        title:'版本号',
        key: 'version_code',
        align: 'center',
    },
    {
        title:'创建时间',
        key: 'created_at',
        align: 'center',
        render:timeRender('created_at')
    },
    {
        title:'更新时间',
        key: 'updated_at',
        align: 'center',
        render:timeRender('updated_at')
    }
]
export const qualification_list_fields = [
    {
        title:'名称',
        key: 'name',
        align: 'center',
        minWidth: 80
    },
    {
        title:'是否冻结',
        key: 'has_frozen',
        align: 'center',
        width: 100,
        render(h, { row }) {
            return <span
            style={{color:row.has_frozen ? WARNING : SUCCESS}}
            >{ row.has_frozen ? '是' : '否' }</span>
        }
    },
    {
        title:'备注',
        key: 'remark',
        align: 'center',
        minWidth: 200,
    },
    {
        title:'创建时间',
        key: 'created_at',
        align: 'center',
        width: 130,
        render:timeRender('created_at')
    },
    {
        title:'更新时间',
        key: 'updated_at',
        align: 'center',
        width: 130,
        render:timeRender('updated_at')
    }
]